import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import * as Clipboard from "expo-clipboard";

type Props = {
  shareUrl: string;
};

const ShareUrlComponent: React.FC<Props> = ({ shareUrl }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await Clipboard.setStringAsync(shareUrl);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  };

  return (
    <View style={styles.shareUrlContainer}>
      <Text style={styles.shareUrl} numberOfLines={1}>
        {shareUrl}
      </Text>
      <TouchableOpacity
        style={[styles.copyButton, isCopied && styles.copiedButton]}
        onPress={handleCopyLink}
        disabled={isCopied}
      >
        <Text style={styles.copyButtonText}>
          {isCopied ? "Copied!" : "Copy link"}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  shareUrlContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 10,
    marginBottom: 16,
  },
  shareUrl: {
    fontSize: 15,
    color: "#000000",
    opacity: 0.5,
    letterSpacing: -0.3,
  },
  copyButton: {
    backgroundColor: "#0F9129",
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 100,
    width: 120,
    justifyContent: "center",
    alignItems: "center",
  },
  copiedButton: {
    backgroundColor: "#6B7280",
  },
  copyButtonText: {
    fontSize: 16,
    fontWeight: "600",
    color: "#FFFFFF",
  },
});

export default ShareUrlComponent;
